import { render, staticRenderFns } from "./default.vue?vue&type=template&id=312f7510&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/navigation/Navbar.vue').default,Sidebar: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/navigation/sidebar/Sidebar.vue').default,ThemeToggle: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/global/ThemeToggle.vue').default,JobSearch: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/jobs/filters/JobSearch.vue').default,JobsSidebarList: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/jobs/lists/JobsSidebarList.vue').default})
